var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.7459 17.4C1.85446 17.4 1.09625 16.8976 0.680903 16.0345C0.263594 15.1715 0.314536 14.2021 0.81609 13.3953L8.07098 1.71944C8.5216 0.993977 9.20144 0.599976 10.0008 0.599976C10.7982 0.599976 11.48 0.996061 11.9286 1.71944L19.1855 13.3953C19.687 14.2021 19.736 15.1715 19.3207 16.0345C18.9034 16.8997 18.1452 17.4 17.2557 17.4H2.7459ZM10.0184 10.8C9.35562 10.8 8.81836 10.2627 8.81836 9.6V4.8C8.81836 4.13726 9.35562 3.6 10.0184 3.6C10.6811 3.6 11.2184 4.13726 11.2184 4.8V9.6C11.2184 10.2627 10.6811 10.8 10.0184 10.8ZM10.0184 15C9.35562 15 8.81836 14.4627 8.81836 13.8C8.81836 13.1373 9.35562 12.6 10.0184 12.6C10.6811 12.6 11.2184 13.1373 11.2184 13.8C11.2184 14.4627 10.6811 15 10.0184 15Z",
    fill: "#D7A700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.f3683b749d7c951bb81d83879ca28a10.svg";
export { ForwardRef as ReactComponent };